import React, { useCallback } from 'react';
import styled from 'styled-components';
import Floater from 'gatsby-theme-core/src/components/floater/float-children';
import CoreButton from 'gatsby-theme-core/src/components/button/index';
import CoreImage from 'gatsby-theme-core/src/components/image';
import { getVariantPropFromString } from 'gatsby-theme-core/src/components/button/get-variant';
import PhoneAlt from 'icons/src/PhoneAlt';
import Envelope from 'icons/src/Envelope';
import User from 'icons/src/UserDezz';
import ChevronLeft from 'icons/src/ChevronLeft';
import ChevronRight from 'icons/src/ChevronRight';
import ArrowLeft from 'icons/src/ArrowLeft';
import ArrowRight from 'icons/src/ArrowRight';
import ArrowRightUp from 'icons/src/ArrowRightUp';
import { useModals } from '../../context/modals';

const useButtonOnClick = (onClick, openModalWithIdentifier) => {
  const { identifierIsModal, setModalOpen } = useModals();
  const openModalFunction = useCallback(
    () => setModalOpen(openModalWithIdentifier, true),
    [
      setModalOpen,
      openModalWithIdentifier,
    ],
  );
  return useCallback((...args) => {
    const openModal = identifierIsModal(openModalWithIdentifier);
    if (openModal) {
      openModalFunction(...args);
    }
    if (onClick) {
      onClick(...args);
    }
  }, [
    openModalFunction,
    identifierIsModal,
    openModalWithIdentifier,
    onClick,
  ]);
};

const prefixImage = (icon) => function PrefixImage() {
  return <CoreImage image={icon} />;
};

const defineIcon = (icon) => {
  if (icon === 'phone') {
    return function PhoneIcon() {
      return <PhoneAlt />;
    };
  }
  if (icon === 'envelope') {
    return function EnvelopeIcon() {
      return <Envelope />;
    };
  }
  if (icon === 'user') {
    return function UserIcon() {
      return <User />;
    };
  }
  if (icon === 'chevron-left') {
    return function ChevronLeftIcon() {
      return <ChevronLeft />;
    };
  }
  if (icon === 'chevron-right') {
    return function ChevronRightIcon() {
      return <ChevronRight />;
    };
  }
  if (icon === 'arrow-left') {
    return function ArrowLeftIcon() {
      return <ArrowLeft />;
    };
  }
  if (icon === 'arrow-right') {
    return function ArrowRightIcon() {
      return <ArrowRight />;
    };
  }
  if (icon === 'arrow-right-up') {
    return function ArrowRightUpIcon() {
      return <ArrowRightUp />;
    };
  }
  return null;
};

const Button = ({
  className,
  id,
  nth = 0,
  text,
  variant,
  link,
  toPage,
  size,
  width,
  forceLinkOpenInNewTab = false,
  onClick = null,
  isPrimaryCta = false,
  openModalWithIdentifier = null,
  eventActionResult = undefined, // can be set from shadow
  icon,
  predefinedIcon,
  appendPredefinedIcon,
}) => {
  const onClickFn = useButtonOnClick(onClick, openModalWithIdentifier);
  const imageIcon = icon ? prefixImage(icon) : null;
  const libIcon = predefinedIcon ? defineIcon(predefinedIcon) : null;
  const appendLibIcon = appendPredefinedIcon ? defineIcon(appendPredefinedIcon) : null;
  return (
    <Floater useFloater={isPrimaryCta}>
      <CoreButton
        className={className}
        key={id}
        to={toPage?.slug ? toPage.slug : link}
        onClick={onClickFn}
        {...getVariantPropFromString(variant)}
        large={size === 'large'}
        wide={width === 'wide'}
        nth={nth}
        eventActionResult={openModalWithIdentifier ? 'popup' : eventActionResult}
        forceLinkOpenInNewTab={forceLinkOpenInNewTab}
        prefixIcon={imageIcon || libIcon}
        appendIcon={appendLibIcon}
      >
        {text}
      </CoreButton>
    </Floater>
  );
};

export default styled(Button)``;
